var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTyperightUp = function SvgTyperightUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.467 14.829 5.157-5.157h-3.95a.5.5 0 1 1 0-1h5.157a.5.5 0 0 1 .5.5v5.156a.5.5 0 1 1-1 0V10.38l-5.157 5.157a.5.5 0 1 1-.707-.707Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.075 4.93c3.905 3.904 3.905 10.236 0 14.141-3.905 3.906-10.237 3.906-14.142 0-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0ZM5.64 5.635a9 9 0 1 1 12.728 12.728A9 9 0 0 1 5.64 5.636Z",
    fill: "currentColor"
  })));
};
export { SvgTyperightUp as ReactComponent };
export default __webpack_public_path__ + "8a054fed075afc5437d63f1e80adce76.svg";